import React from 'react';

const WriterDashboardPage = () => {
  return (
    <div>
      <h1>Writer Dashboard</h1>
    </div>
  );
};

export default WriterDashboardPage;
